<script>
  import ChartLabelBubble from './ChartLabelBubble.svelte';
  import ChartLabelBubbleOld from './ChartLabelBubbleOld.svelte';
  import ChartLabelArrow from './ChartLabelArrow.svelte';

  export let Label;
  export let StartDate;
  export let EndDate;
  export let Height;
  export let OriginY;
  export let AdjustStamp;
  export let CurrentStyle;
  export let GanttStore;

</script>

  {#if Label._timePoint !== ""}

    {#if Label._shape === "B"}

      <!--
      <ChartLabelBubbleOld
        Label={Label}
        StartDate={StartDate}
        EndDate={EndDate}
        Height={Height}
        OriginY={OriginY}
        AdjustStamp={AdjustStamp}
        CurrentStyle={CurrentStyle}
        GanttStore={GanttStore}
      />
      -->

      <ChartLabelBubble
        Label={Label}
        StartDate={StartDate}
        EndDate={EndDate}
        Height={Height}
        OriginY={OriginY}
        AdjustStamp={AdjustStamp}
        CurrentStyle={CurrentStyle}
        GanttStore={GanttStore}
      />

    {/if}

    {#if Label._shape === "T"}

      <ChartLabelArrow
        Label={Label}
        StartDate={StartDate}
        EndDate={EndDate}
        Height={Height}
        OriginY={OriginY}
        AdjustStamp={AdjustStamp}
        CurrentStyle={CurrentStyle}
        GanttStore={GanttStore}
      />

    {/if}

  {/if}
